import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from "./App";
import {Metric} from "web-vitals";
import {setupReady} from "./lib/setup";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

setupReady.then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
function sendToAnalytics(metric: Metric) {
  const { id, name, value } = metric;
  gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? value * 1000 : value), // values must be integers
  });
}
reportWebVitals(sendToAnalytics);
